import { Injectable } from '@angular/core';
import { IntegracaoAlvoProdutoModel } from '@app/data';
import { ApiService } from '@app/gateway';
import type { DashPeriodQueryPayload } from '@app/pages/dashboard/shared';

@Injectable({ providedIn: 'root' })
export class IntegracaoService {
  constructor(protected readonly apiService: ApiService) {}

  public async alvoProdutos(data: DashPeriodQueryPayload): Promise<IntegracaoAlvoProdutoModel[]> {
    try {
      const path: string = `integracao/alvoProdutos`;
      const result: IntegracaoAlvoProdutoModel[] = await this.apiService.post({ path, data });
      return result;
    } catch (e: unknown) {
      const message: string = e instanceof Error ? e.message : 'Failed to load integration products.';
      throw new Error(message, { cause: e });
    }
  }
}
